import { toast } from 'react-toastify';
import errorToastIcon from '../../assets/error_icon.svg'
import CommonColorUtils from '../../utils/common_colors';

// Function to show the error toast with a custom message
export const showErrorToast = (toastMessage) => {
    toast.dismiss();
    toast.error(<div style={{
        display: 'flex',
        alignItems: 'center',
        color: CommonColorUtils.primaryErrorDarkColor,
        backgroundColor: CommonColorUtils.primaryErrorLightRed,
        padding: ' 0px 10px',
        borderRadius: '8px'
    }}>
        <img src={errorToastIcon} alt="Error Toast" style={{ marginRight: '10px' }} />
        <span>{toastMessage}</span>
    </div>, {
        position: "top-center",        // Position at the top center
        autoClose: 2000,               // Auto close after 2 seconds
        hideProgressBar: true,         // Hide progress bar
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        icon: false,                   // No default icon
        closeButton: false,            // Remove close button
        style: {
            padding: 0,
            backgroundColor: 'transparent',
            boxShadow: 'none',
            width: '400px'              // Custom width adjustment
        }
    });
};
